var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"detailmain",class:[
    _vm.youdi ? 'dibu' : '',
    _vm.cuurentPathName === '/make_nutrition'
      ? 'grayFooterBg1'
      : _vm.cuurentPathName === '/aboutUs'
      ? 'grayFooterBg2'
      : _vm.cuurentPathName === '/quality'
      ? 'grayFooterBg3'
      : _vm.cuurentPathName === '/productSeries'
      ? 'grayFooterBg4'
      : _vm.cuurentPathName === '/blog'
      ? 'grayFooterBg5'
      : _vm.cuurentPathName === '/index'
      ? 'grayFooterBg7'
      : _vm.cuurentPathName === '/fulfillment'
      ? 'grayFooterBg8'
      : 'grayFooterBg6',
  ],style:({
    'padding-top':
      _vm.shownav == false || _vm.shengyi == true || _vm.ketogenesis == true ? '0' : '',
  }),attrs:{"id":"app"}},[(_vm.showCheck)?_c('div',[_c('navsHg'),_c('haiguanCheck'),(!_vm.hiddenFooter && _vm.showwei && _vm.showit && !_vm.shengyi && !_vm.ketogenesis)?_c('foot',{class:_vm.mainmohu ? 'mohu' : ''}):_vm._e(),(!_vm.hiddenFooter && !_vm.showwei && _vm.showit && !_vm.shengyi && !_vm.ketogenesis)?_c('foot2',{class:_vm.mainmohu ? 'mohu' : ''}):_vm._e()],1):_c('div',[(_vm.shownav && !_vm.shengyi && !_vm.ketogenesis)?_c('navs',{class:_vm.mainmohu ? 'mohu' : '',on:{"getback":_vm.getbackinfo}}):_vm._e(),_c('router-view',{class:_vm.mohu ? 'mohu' : '',on:{"getback":_vm.getbackinfo_main}}),(!_vm.hiddenFooter && _vm.showwei && _vm.showit && !_vm.shengyi && !_vm.ketogenesis)?_c('foot',{class:_vm.mainmohu ? 'mohu' : ''}):_vm._e(),(!_vm.hiddenFooter && !_vm.showwei && _vm.showit && !_vm.shengyi && !_vm.ketogenesis)?_c('foot2',{class:_vm.mainmohu ? 'mohu' : ''}):_vm._e(),(!_vm.showwei)?_c('div',{staticClass:"qusbottomheight"}):_vm._e(),(_vm.bottomshow)?_c('div',{staticClass:"bottomheight"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }